// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#shu-booking-form .trip-details__intro{margin-top:0;margin-bottom:1em}#shu-booking-form .trip-details__custom-location-intro{margin:1em 0}#shu-booking-form .trip-details__has-children,#shu-booking-form .trip-details__non-default-locations{margin-top:1em}\n", ""]);
// Exports
module.exports = exports;
